import React, { Fragment } from 'react';

import { Tooltip } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import {
  SUPPORTED_TYPES,
  IMAGE_FILE,
  AUDIO_FILE,
  VIDEO_FILE,
  SVG_FILE,
} from 'components/FileUpload/constants';
import messages from 'components/FileUpload/messages';

const defaultSupportedMedia = [
  SUPPORTED_TYPES[IMAGE_FILE],
  SUPPORTED_TYPES[AUDIO_FILE],
  SUPPORTED_TYPES[VIDEO_FILE],
];

function SupportedMediaTooltip(props) {
  const { supportedMedia = defaultSupportedMedia } = props;
  return (
    <Tooltip
      overlayClassName="tooltip-light"
      arrowPointAtCenter
      title={
        <div>
          {supportedMedia.includes(SUPPORTED_TYPES[IMAGE_FILE]) && (
            <Fragment>
              <p className="font-bold margin-top-xs margin-btm-xxs color-grey-10">
                <FormattedMessage {...messages.recommendedSpecsImage} />
              </p>
              <p
                className="margin-none color-grey-9"
                style={{ lineHeight: 1.4 }}
              >
                <FormattedHTMLMessage {...messages.recommendedImageSpecs} />
              </p>
            </Fragment>
          )}
          {supportedMedia.includes(SUPPORTED_TYPES[SVG_FILE]) && (
            <Fragment>
              <p className="font-bold margin-top-xs margin-btm-xxs color-grey-10">
                <FormattedMessage {...messages.recommendedSpecsSVG} />
              </p>
              <p
                className="margin-none color-grey-9"
                style={{ lineHeight: 1.4 }}
              >
                <FormattedHTMLMessage {...messages.recommendedSVGSpecs} />
              </p>
            </Fragment>
          )}
          {supportedMedia.includes(SUPPORTED_TYPES[VIDEO_FILE]) && (
            <Fragment>
              <p className="font-bold margin-top-xs margin-btm-xxs margin-no-bottom  color-grey-10">
                <FormattedMessage {...messages.recommendedSpecsVideo} />
              </p>
              <p
                className="margin-none color-grey-9"
                style={{ lineHeight: 1.4 }}
              >
                <FormattedHTMLMessage {...messages.recommendedVideoSpecs} />
              </p>
            </Fragment>
          )}
          {supportedMedia.includes(SUPPORTED_TYPES[AUDIO_FILE]) && (
            <Fragment>
              <p className="font-bold margin-top-xs margin-btm-xxs margin-no-bottom color-grey-10">
                <FormattedMessage {...messages.recommendedSpecsAudio} />
              </p>
              <p
                className="margin-none color-grey-9"
                style={{ lineHeight: 1.4 }}
              >
                <FormattedHTMLMessage {...messages.recommendedAudioSpecs} />
              </p>
            </Fragment>
          )}
        </div>
      }
    >
      {props.children}
    </Tooltip>
  );
}

export default React.memo(SupportedMediaTooltip);
